<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '@/stores/global-store'
import { useAppStore } from '@/stores/integration'
import { VaButton, VaIcon, VaAvatar, VaNavbar, VaDropdown } from 'vuestic-ui'
import StakeModal from '../modal/StakeModal.vue'
import WithdrawModal from '../modal/WithdrawModal.vue'
import DepositModal from '../modal/DepositModal.vue'
import { ArrowPathIcon, ClockIcon, CurrencyDollarIcon, DocumentDuplicateIcon } from '@heroicons/vue/24/solid'
import router from '../../router'
import { useI18n } from 'vue-i18n'

const { isSidebarMinimized } = storeToRefs(useGlobalStore())
const appStore = useAppStore()
const { t: $t } = useI18n()

const abrirNovaStake = () => appStore.showBotModal()
const abrirSaque = () => (appStore.withdrawModal = true)
const abrirDeposito = () => appStore.showDepositModal()
const abrirSaldo = () => appStore.showCopyModal()

const logout = () => appStore.logout()

const historico = () => router.push('/history')
const profile = () => router.push('/profile')
const home = () => router.push('/dashboard')
</script>

<template>
  <VaNavbar class="justify-between flex dark:bg-[#020c1b] w-full dark:text-white px-6 py-2 shadow-sm">
    <div class="w-full flex justify-between items-center">
      <div class="flex items-center space-x-4 min-w-[250px]">
        <VaIcon
          name="menu"
          size="24px"
          class="cursor-pointer text-white md:hidden"
          @click="isSidebarMinimized = !isSidebarMinimized"
        />
        <div class="flex items-center space-x-2" @click="home">
          <img src="/image/logo.svg" alt="Logo" class="w-7 h-7" />
          <span class="font-semibold text-lg tracking-wide text-white">PRIMEOPTIONS</span>
        </div>
      </div>

      <div class="hidden md:block w-2/3">
        <div class="flex items-center space-x-4 grow justify-between">
          <VaButton color="#d600c0" class="text-white font-semibold w-64 px-8 py-2 rounded-md" @click="abrirNovaStake">
            {{ $t('navbar.nova_stake') }}
          </VaButton>
          <VaButton
            preset="secondary"
            border-color="#d600c0"
            class="border border-[#d600c0] text-white hover:bg-[#1a1a2e] font-semibold w-64 px-8 py-2 rounded-md"
            @click="abrirSaque"
          >
            {{ $t('navbar.sacar') }}
          </VaButton>
          <VaButton color="#01080E" class="bg-[#01080E] border text-white w-64 py-2" @click="abrirDeposito">
            {{ $t('navbar.trazer_corretora') }}
          </VaButton>
          <VaButton color="#01080E" class="border text-white w-64 py-2" @click="abrirSaldo">
            {{ $t('navbar.saldo') }}
            <span class="text-[#00ff80] font-bold ml-1">
              {{ Number(appStore.balance).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
            </span>
          </VaButton>
        </div>
      </div>

      <div class="flex items-center space-x-5 md:min-w-[100px] justify-end">
        <VaDropdown placement="bottom-end" class="z-50">
          <template #anchor>
            <VaAvatar src="/image/avatar.png" size="42px" class="cursor-pointer border border-black rounded-full" />
          </template>

          <div class="bg-[#0C0E1B] text-white w-40 rounded-lg shadow-lg overflow-hidden">
            <button class="w-full text-left px-4 py-3 hover:bg-[#1A1D2F] transition" @click="profile">
              <VaIcon name="person" class="mr-2" />
              Perfil
            </button>
          </div>
          <div class="bg-[#0C0E1B] text-white w-40 rounded-lg shadow-lg overflow-hidden">
            <button class="w-full text-left px-4 py-3 hover:bg-[#1A1D2F] transition" @click="logout">
              <VaIcon name="logout" class="mr-2" />
              {{ $t('navbar.sair') }}
            </button>
          </div>
        </VaDropdown>
      </div>
    </div>
  </VaNavbar>
  <div
    class="fixed bottom-0 left-0 w-full bg-[#010D1A] border-t border-[#1F2436] flex justify-around py-2 md:hidden z-50"
  >
    <button class="flex flex-col items-center text-white text-xs hover:text-[#D926A9] transition" @click="abrirSaque">
      <ArrowPathIcon class="w-6 h-6 mb-1 text-[#D926A9]" />
      {{ $t('navbar.sacar') }}
    </button>

    <button
      class="flex flex-col items-center text-white text-xs hover:text-[#D926A9] transition"
      @click="abrirNovaStake"
    >
      <CurrencyDollarIcon class="w-6 h-6 mb-1 text-[#D926A9]" />
      {{ $t('navbar.nova_stake') }}
    </button>

    <button
      class="flex flex-col items-center text-white text-xs text-center hover:text-[#D926A9] transition"
      @click="abrirDeposito"
    >
      <DocumentDuplicateIcon class="w-6 h-6 mb-1 text-[#D926A9]" />
      {{ $t('navbar.trazer_corretora') }}
    </button>

    <button class="flex flex-col items-center text-white text-xs hover:text-[#D926A9] transition" @click="historico">
      <ClockIcon class="w-6 h-6 mb-1 text-[#D926A9]" />
      {{ $t('navbar.historico') }}
    </button>
  </div>
  <StakeModal />
  <WithdrawModal />
  <DepositModal />
</template>
